import React, {Children, cloneElement} from 'react'
import {Box, Text} from 'grommet'
import {withTheme} from 'styled-components'

const ErrorMessage = ({error, theme, children, ...rest}) => {
  const {formField} = theme
  const borderColor = theme.global.colors['status-critical']

  const normalizedChildren = children
    ? Children.map(children, child => {
        if (child) {
          return cloneElement(child, {
            style: {
              borderColor: error ? borderColor : null,
            },
            error,
          })
        }
        return child
      })
    : null

  return (
    <Box margin={error?{bottom:'0'}:{...formField.margin}} {...rest}>
      {normalizedChildren}
      {error && (
        <Text
          style={{marginBottom:'0'}}
          {...formField.error}
          color={theme.global.colors['status-critical']}
        >
          {error}
        </Text>
      )}
    </Box>
  )
}

export default withTheme(ErrorMessage)
